module.exports = __webpack_public_path__ + "static/monitor-lg-1eaef5ef4ba94a35d57d26c8cf18ec9b.png";